module.exports = __webpack_public_path__ + "img/drug_enforcement-stage_5.3.aa4bb80f.jpg";